const resolveAdUrl = (ad) => {
  switch (ad.advertisement_type) {
    case "company_properties":
      return `/company/${ad.company?.id}/${
        ad.company ? sanitizeTitle(ad.company.name) : ""
      }`;
    case "developer_projects":
      return `/project/${ad.developer?.id}/${
        ad.developer ? sanitizeTitle(ad.developer.name) : ""
      }`;
    case "property":
      return `/property/${ad.property?.id}/${sanitizeTitle(ad.property.title)}`;
    default:
      return ad.external_link;
  }
};

const sanitizeTitle = (title) => {
  return title.replace(/[^a-z0-9]/gi, "-").toLowerCase();
};

export default resolveAdUrl;
